import {
  MuiDivider,
  MuiListSubheader,
  MuiMenuItem
} from "@dealer-center/core-components";
import type { NavigationMenuItemInterface } from "@dealer-center/ddc-api-commoncontainer-interface";
import {
  isNavigationMenuItemInterfaceHeader,
  isNavigationMenuItemInterfaceParent
} from "@dealer-center/ddc-api-commoncontainer-interface";

export const UserMenuPopup = ({
  handleItemClicked,
  navToUse
}: {
  handleItemClicked: (itemClicked: NavigationMenuItemInterface) => void;
  navToUse: NavigationMenuItemInterface[];
}) => {
  return navToUse.reduce<React.ReactNode[]>((acc, item, index) => {
    if (isNavigationMenuItemInterfaceHeader(item)) {
      return [
        ...acc,
        <MuiListSubheader key={item.label}>{item.label}</MuiListSubheader>
      ];
    }
    if (isNavigationMenuItemInterfaceParent(item)) {
      return [
        ...acc,
        <MuiMenuItem disabled key={item.label}>
          {item.label}
        </MuiMenuItem>,
        ...item.links.map(child => (
          <MuiMenuItem
            key={child.label}
            onClick={() => handleItemClicked(child)}
          >
            {child.label}
          </MuiMenuItem>
        )),
        <MuiDivider key={item.label + "-divider"} />
      ];
    }

    return [
      ...acc,
      <MuiMenuItem key={item.label} onClick={() => handleItemClicked(item)}>
        {item.label}
      </MuiMenuItem>,
      navToUse.length - 1 === index ? undefined : (
        <MuiDivider key={item.label + "-divider"} />
      )
    ];
  }, []);
};
